module.exports = __webpack_public_path__ + "img/logopv.eeb52064.png";